import { render } from "./TestItemPage.vue?vue&type=template&id=2b394f5c"
import script from "./TestItemPage.vue?vue&type=script&lang=js"
export * from "./TestItemPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductManage/ConfigManagement/components/Motor/TestItemPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b394f5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b394f5c', __exports__)) {
    api.reload('2b394f5c', __exports__)
  }
  
  module.hot.accept("./TestItemPage.vue?vue&type=template&id=2b394f5c", () => {
    api.rerender('2b394f5c', render)
  })

}


export default __exports__